import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { ReactSortable } from "react-sortablejs";
import { joinLmoviepickget } from "../../../../api/handleapi";
import { imgpath } from "../../../../Config/config";
import logo from "../../../../assets/Gaffer Transparent Logo1.png";
import "./OrderDraft.css";

const OrderDraft = ({
  leagueId,
  handlerUsers
}) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const { data: { data } } = await joinLmoviepickget(leagueId, 0);
      setUsers(data.orderedPlayers);
    };

    fetchUsers();
  }, []);

  return (
    <div className="p-4 pt-0">
      <ReactSortable
        list={users}
        setList={(usersList) => {
          setUsers(usersList);
          handlerUsers(usersList);
        }}
        animation={200}
      >
        {users.map((user, index) => (
          <div
            key={user.id}
            className="p-2 mb-2 bg-gray-100 rounded cursor-move border d-flex align-items-center cursor-pointer bg-hover-primary reorder-users"
            style={{ cursor: 'pointer' }}
          >
            <div className="me-3 py-2 px-3 bg-primary rounded text-white">{index + 1}</div>

            <div>
              {user.image?.includes("https://m.media-amazon.com/images") ? 
                <img src={user.image} alt="img" width={30} height={30} className="rounded-circle me-3"/> : 
                <img src={imgpath + user.image} width={30} height={30} className="rounded-circle me-3" onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}/>
              }

              {user.name}
            </div>
          </div>
        ))}
      </ReactSortable>
    </div>
  )
}

export default OrderDraft;